import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const ResetPassword = ({ onSuccess }) => {
  const { user, updateUser, logout } = useAuth();
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword.length < 6) { setError('Password must be at least 6 characters.'); return; }
    if (newPassword !== confirm) { setError('Passwords do not match.'); return; }

    setLoading(true);
    try {
      await axios.post(`${API_URL}/auth/change-password`, {
        user_id: user.user_id,
        new_password: newPassword,
      });
      updateUser({ must_reset_password: false });
      if (onSuccess) onSuccess();
    } catch (err) {
      setError(err.response?.data?.error || 'Error changing password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', background: 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px',
    }}>
      <div style={{
        background: '#fff', borderRadius: '16px', padding: '48px 40px',
        width: '100%', maxWidth: '420px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <div style={{ fontSize: '36px', marginBottom: '10px' }}>🔐</div>
          <h2 style={{ fontSize: '22px', fontWeight: '800', color: '#1e293b', margin: 0 }}>Set Your Password</h2>
          <p style={{ color: '#64748b', marginTop: '8px', fontSize: '14px' }}>
            Welcome, {user?.name}! Please set a new password before continuing.
          </p>
        </div>

        <div style={{ padding: '10px 14px', background: '#fef3c7', border: '1px solid #fde68a', borderRadius: '8px', marginBottom: '20px', fontSize: '13px', color: '#92400e' }}>
          ⚠️ Your account requires a password reset before you can access the system.
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">New Password</label>
            <input
              type="password"
              className="form-control"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              placeholder="Minimum 6 characters"
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label className="form-label">Confirm Password</label>
            <input
              type="password"
              className="form-control"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              placeholder="Repeat your new password"
              required
            />
          </div>

          {error && (
            <div style={{
              padding: '12px 14px', background: '#fef2f2', border: '1px solid #fca5a5',
              borderRadius: '8px', color: '#991b1b', fontSize: '14px', marginBottom: '16px',
            }}>
              ❌ {error}
            </div>
          )}

          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
            style={{ width: '100%', justifyContent: 'center', padding: '14px', fontSize: '15px' }}
          >
            {loading ? '⏳ Saving…' : 'Set Password & Continue →'}
          </button>
          <button
            type="button"
            onClick={logout}
            style={{ width: '100%', marginTop: '12px', background: 'none', border: 'none', color: '#94a3b8', fontSize: '13px', cursor: 'pointer' }}
          >
            Sign out
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
